import React from "react";
import { pains } from "../data/content";
export function Problem() {
  return <section className="bg-white py-20 md:py-28" aria-labelledby="problem-title" style={{
    backgroundColor: "#FBF7EE",
    backgroundImage: "none",
    backgroundSize: "auto",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }} data-id="element-207" data-mp="2pf8qoakywbo2">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 md:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-208" data-mp="2gdre326rqs44">
        <div className="lg:sticky lg:top-24 lg:self-start" data-id="element-209" data-mp="21p4ma0zyg7w0">
          <h2 id="problem-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-210" data-mp="26gcxn2kui3bt">
            ¿Te pasa que trabajás mucho, pero sentís que nunca avanzás?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-211" data-mp="1wqbln95robd9">
            El problema no siempre es la falta de ganas.{" "}
            <strong className="font-bold text-ink" data-id="element-212" data-mp="1isd5pzbss6vn">Muchas veces es no saber cuál es el primer paso.</strong>
          </p>
        </div>

        <ul className="divide-y divide-line border-y border-line" data-id="element-213" data-mp="1nrzkid79xv6k">
          {pains.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-start gap-5 py-7" data-id="element-214" data-mp="ob3y03k8tret">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sun text-ink" data-id="element-215" data-mp="ocye94kkkvck">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-216" data-mp="xbinzg85juon" />
              </span>
              <p className="pt-2.5 text-lg font-medium leading-snug text-ink" data-id="element-217" data-mp="x9fm9yxn0d43">{text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}